import axios from 'axios';

const state = () => ({
	formationData: {},
});

const getters = {
	formationData: (state) => {
		return state.formationData;
	},
};
const mutations = {
	formationData(state, infos) {
		state.formationData = infos;
	},
};
const actions = {
	async getFormationData(store, { idFormation }) {
		const res = await axios.get('/api/formation/' + idFormation);
		store.commit('formationData', res.data.formationData);
		return res.data.formationData;
	},
	async getAllFormationsOfUser() {
		if (localStorage.getItem('token') != null)
			axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
		const res = await axios.get('/api/formation');
		return res.data.formations;
	},
	async fetchFormationsByUserId(store, { userId }) {
		const res = await axios.get(`/api/users/${userId}/formations`);
		return res.data.formations;
	},
	/**
	 * Calls backend self-healing so `last_exercice` can resync when the user opens an exercise
	 * (mitigates stuck formation when score POST failed silently for infinity exercise users).
	 * Errors are logged only; exercise load must continue.
	 *
	 * @param {object} payload
	 * @param {string} payload.idFormation
	 * @param {string} payload.idExercice
	 *
	 * @created_at 05/05/2026 by AI (Composer)
	 */
	async selfHealingExercise(store, { idFormation, idExercice }) {
		try {
			await axios.post('/api/formation/self-healing-exercise', { idFormation, idExercice });
		} catch (error) {
			console.error('[formation/selfHealingExercise]', error);
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
